import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { get, head, map, filter, isEmpty } from "lodash";
import { useHistory, useParams } from "react-router-dom";
import {
  Paper,
  Table,
  Box,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
} from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import GridOnIcon from "@material-ui/icons/GridOn";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import LocationIcon from "@material-ui/icons/LocationOn";
import { makeStyles, withStyles } from "@material-ui/core/styles";

import { Map } from "./Map";
import { Separator } from "./Separator";
import { AddressSearch } from "./AddressSearch";
import { confirmModal } from "../../v2_actions/ui";
import {
  galleryList, galleryDetailedList, DEFAULT_NUM_ITEMS_PER_GALLERY_PAGE
} from "../../v2_actions/gallery";
import LoadingSpinner from "../../components/LoadingSpinner";
import { SideBarGalleryFilter } from "./SideBarGalleryFilter";
import { replaceSpacesWithDashes } from "v2_actions/nav";
import { showSuccess, showError } from "../../v2_actions/error";
import { setSelectedGallery, setEditingGallery } from "../../actions/gallery";
import { photographerLedgerList } from "../../v2_actions/photographer_ledger";
import { getDefaultLocationForUser, setMapCenter } from "../../v2_actions/map";
import { facialRecognitionList } from "../../v2_actions/facial_recognition";
import { bibNumberRecognitionList } from "../../v2_actions/bib_recognition"
import { processGalleryPhotographsList } from "v2_actions/process_gallery_photographs";
import Pagination from "../TablePagination";

const StyledTableCell = withStyles((theme) => ({
  head: {
    fontSize: 12,
    height: 10.823,
    color: "black",
    fontWeight: "bold",
    backgroundColor: "#E5E5E5",
    border: "1px solid #e0e0e0",
    textAlign: "left",
  },
  body: {
    height: 25,
    fontSize: 12,
    fontWeight: 400,
    textAlign: "left",
    fontFamily: "Helvetica",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "white",
      height: 25,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  container: {
    zIndex: 99,
    opacity: "0.88",
    position: "relative",
    padding: 10,
  },
  available_to_purchase_gallery: {
    "& *": {
      color: "#000",
    },
  },
  unavailable_to_purchase_gallery: {
    "& *": {
      color: "#868686",
    },
  },
  selectedInput: {
    width: "7px",
    textAlign: "center",
    "& .MuiInputBase-root": {
      height: "30px",
    },
  },
  photoCount: {
    textAlign: "center",
  },
  clickIcon: {
    cursor: "pointer",
  },
  actionWrapper: {
    top: "70px",
    right: "10px",
    position: "absolute",
  },
}));

function format(x) {
  return Number.parseFloat(x).toFixed(2);
}

const SelectRow = ({
  row,
  history,
  dispatch,
  onDeleted,
  onAvailableToPurchase,
  onUnavailableToPurchase,
}) => {
  const gallery_id = get(row, "id");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedValue, setSelectedValue] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    setAnchorEl(null);
    setSelectedValue(event.target.getAttribute("value"));

    // Get attribute value from selected option
    let value = event.target.getAttribute("value");
    if (value === "EDIT") {
      dispatch(setEditingGallery(row));
    }
  };

  const onCopyGalleryUrlToClipboard = (row) => {
    const galleryDbId = get(row, "db_id");
    const gallerySessionName = replaceSpacesWithDashes(
      get(row, "session_name"),
    );
    const galleryUrl = `${window.location.origin}/customer/gallery/${gallerySessionName}/${galleryDbId}`;

    navigator.clipboard
      .writeText(galleryUrl)
      .then(showSuccess("Success", "Gallery name copied to clipboard"));
  };
  const onRunFacialRecognition = (row) => {
    const galleryId = get(row, "id");
    dispatch(facialRecognitionList.indexGalleryForFacialRecognition(galleryId));
    showSuccess("Running");
  };

  const onIndexBibRecognition = (row) => {
    const galleryId = get(row, "id");
    dispatch(bibNumberRecognitionList.indexGallery(galleryId))
    showSuccess("Indexing")
  }

  const onProcessGalleryPhotographs = (row) => {
    const galleryId = get(row, "id");
    dispatch(
      processGalleryPhotographsList.processGalleryPhotographs(galleryId),
    );
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            // maxHeight: ITEM_HEIGHT * 4.5,
            width: "20ch",
          },
        }}
        // Should Open in bottom left side
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <MenuItem
          onClick={() => {
            history.push(`/photographer/gallery/${gallery_id}/view`);
          }}
          value="VIEW"
        >
          View Photos
        </MenuItem>
        <MenuItem onClick={handleClose} value="EDIT">
          Edit Gallery
        </MenuItem>
        <MenuItem value="EDIT" onClick={handleClose}>
          Add Photos
        </MenuItem>
        <MenuItem
          value="COPY_URL"
          onClick={(e) => {
            onCopyGalleryUrlToClipboard(row);
            handleClose(e);
          }}
        >
          Copy Gallery Url
        </MenuItem>
        <MenuItem
          value="RUN_FACIAL_RECOGNITION"
          onClick={(e) => {
            onRunFacialRecognition(row);
            handleClose(e);
          }}
        >
          Run Facial Recognition
        </MenuItem>
        <MenuItem
          value="INDEX_BIB_RECOGNITION"
          onClick={(e) => {
            onIndexBibRecognition(row);
            handleClose(e);
          }}
        >
          Index Bib Recognition
        </MenuItem>
        <MenuItem
          value="PROCESS_GALLERY_PHOTOGRAPHS"
          onClick={(e) => {
            onProcessGalleryPhotographs(row);
            handleClose(e);
          }}
        >
          Process Gallery Photographs
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            onDeleted(row);
            handleClose(e);
          }}
          value="DELETE"
        >
          Delete Gallery
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            onUnavailableToPurchase(row);
            handleClose(e);
          }}
          value="UNAVAILABLE_TO_PURCHASE"
        >
          Unpublish Gallery
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            onAvailableToPurchase(row);
            handleClose(e);
          }}
          value="AVAILABLE_TO_PURCHASE"
        >
          Publish Gallery
        </MenuItem>
        <MenuItem
          value="REPLICATE"
          onClick={(e) => {
            dispatch(galleryDetailedList.get({galleryRef: gallery_id})).then((fullGallery) => {
              const replicatedGallery = {
                shot_at_datetime: fullGallery.shot_at_datetime,
                time_duration_hours: fullGallery.time_duration_hours,
                activity_tags: fullGallery.activity_tags,
                lat: fullGallery.lat,
                lng: fullGallery.lng,
                gallery_event: fullGallery.gallery_event,
                album: fullGallery.album,
                add_gallery_event_logo: fullGallery.add_gallery_event_logo,
                custom_gallery_event_logo: fullGallery.custom_gallery_event_logo,
                can_index_for_facial_recognition: fullGallery.can_index_for_facial_recognition,
                gallery_price: fullGallery.gallery_price,
                gallery_password: fullGallery.gallery_password,
              };
              dispatch(setEditingGallery(replicatedGallery));
              dispatch(setSelectedGallery(null));
              history.push('/photographer/map/new');
            });
            handleClose(e);
          }}
        >
          Replicate Gallery
        </MenuItem>
      </Menu>
    </div>
  );
};

const AllGalleries = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isBusy, setIsBusy] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [age, setAge] = React.useState("");
  const hasAutoSelectedFirstGallery = useRef(false);
  const history = useHistory();
  const galleries = useSelector(() => galleryList.getVisibleObjects());
  const loadingGalleries = useSelector(() => galleryList.isLoading());
  const galleries_excluding_photoart = filter(
    galleries,
    (gallery) => gallery.gallery_type !== "photo_art",
  );

  const formProps = useForm({});
  const {
    handleSubmit,
    control,
    clearErrors,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = formProps;

  const onDeleteSelectedGallery = (json) => {
    const onDeleted = (json) => {
      if (json.errors) {
        showError("Error", JSON.stringify(json.errors));
      } else {
        dispatch(galleryList.invalidateList());
        dispatch(galleryList.fetchListIfNeeded());
        showSuccess("Success", "Gallery deleted");
        setIsBusy(false);
      }
    };

    const onConfirmed = () => {
      setIsBusy(true);
      dispatch(galleryList.deleteObject(json.id)).then(onDeleted);
    };

    dispatch(
      confirmModal({
        can_cancel: true,
        onConfirmed: onConfirmed,
        text: "Are you sure you want to delete this gallery?",
      }),
    );
  };

  const onUnavailableToPurchaseSelectedGallery = (json) => {
    const onUnavailableToPurchase = (json) => {
      if (json.errors) {
        showError("Error", JSON.stringify(json.errors));
      } else {
        dispatch(galleryList.invalidateList());
        dispatch(galleryList.fetchListIfNeeded());
        showSuccess("Success", "Gallery unavailable to purchase");
        setIsBusy(false);
      }
    };

    const onConfirmed = () => {
      const values = Object.assign({}, json, {
        available_to_purchase: false,
      });
      setIsBusy(true);
      dispatch(galleryList.saveObject(values)).then(onUnavailableToPurchase);
    };

    dispatch(
      confirmModal({
        can_cancel: true,
        onConfirmed: onConfirmed,
        text: "Are you sure you want to make this gallery unavailable to purchase?",
      }),
    );
  };

  const onAvailableToPurchaseSelectedGallery = (json) => {
    const onAvailableToPurchase = (json) => {
      if (json.errors) {
        showError("Error", JSON.stringify(json.errors));
      } else {
        dispatch(galleryList.invalidateList());
        dispatch(galleryList.fetchListIfNeeded());
        showSuccess("Success", "Gallery available to purchase");
        setIsBusy(false);
      }
    };

    const onConfirmed = () => {
      const values = Object.assign({}, json, {
        available_to_purchase: true,
      });
      setIsBusy(true);
      dispatch(galleryList.saveObject(values)).then(onAvailableToPurchase);
    };

    dispatch(
      confirmModal({
        can_cancel: true,
        onConfirmed: onConfirmed,
        text: "Are you sure you want to make this gallery available to purchase?",
      }),
    );
  };
  const showMenu = useSelector((state) => state.user.showMenu);
  const handleChange = (event) => {
    setAge(event.target.value);
  };

  useEffect(() => {
    dispatch(photographerLedgerList.fetchListIfNeeded());
  }, []);

  const { gallery_id } = useParams();
  const gallery = useSelector(() => galleryList.getObject(gallery_id));
  const is_ready = !gallery_id || get(gallery, "id");
  const selectedGallery = useSelector((state) => state.gallery.selectedGallery)

  useEffect(() => {
    if (get(gallery, "lat") && get(gallery, "lng")) {
      dispatch(
        setMapCenter({ lat: get(gallery, "lat"), lng: get(gallery, "lng") }),
      );
    }
  }, [get(gallery, "id")]);

  useEffect(() => {
    // Set pagination before fetching to ensure only 20 items are loaded initially
    dispatch(galleryList.updatePaginationNumItemsPerPage(DEFAULT_NUM_ITEMS_PER_GALLERY_PAGE));
    dispatch(galleryList.fetchListIfNeeded());
    if (gallery_id) {
      dispatch(galleryList.ensureObjectLoaded(gallery_id));
    }
  }, [gallery_id]);

  const selectGalleryWithDetail = (galleryId) => {
    if (galleryId === selectedRowId) {
      return;
    }
    setSelectedRowId(galleryId);
    dispatch(galleryDetailedList.get({galleryRef: galleryId})).then((detailedGallery) => {
      dispatch(setSelectedGallery(detailedGallery));
    });
  };

  useEffect(() => {
    if (hasAutoSelectedFirstGallery.current) {
      return;
    }
    const firstRow = head(galleries_excluding_photoart);
    const firstRowId = get(firstRow, "id");
    const galleryExists = !isEmpty(galleries_excluding_photoart) && firstRowId
    if (galleryExists) {
      hasAutoSelectedFirstGallery.current = true;
      setSelectedRowId(firstRowId);
      dispatch(galleryDetailedList.get({galleryRef: firstRowId})).then((detailedGallery) => {
        dispatch(setSelectedGallery(detailedGallery));
      });
    }
  }, [galleries_excluding_photoart]);

  useEffect(() => {
    if (selectedGallery && get(selectedGallery, 'id') !== selectedRowId) {
      setSelectedRowId(get(selectedGallery, 'id'))
    }
  }, [selectedGallery])

  const onSelectGallery = (gallery_id) => {
    history.push(`/photographer/gallery/${gallery_id}/view`);
  };

  return (
    <TableContainer component={Paper} className={classes.container}>
      <Separator height={3} />
      {(isBusy || loadingGalleries) && <LoadingSpinner />}
      <AddressSearch />
      <SideBarGalleryFilter />
      <Box item xs={6} md={2} className={classes.actionWrapper}>
        <LocationIcon
          onClick={() => {
            setShowMap(true);
          }}
          className={classes.clickIcon}
        />
        <GridOnIcon
          onClick={() => {
            setShowMap(false);
          }}
          className={classes.clickIcon}
        />
      </Box>
      <Separator height={23} />

      {!showMap && (
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <StyledTableRow>
              <StyledTableCell align="center" style={{ width: "95px" }}>
                Date
              </StyledTableCell>
              <StyledTableCell align="center">Gallery Name</StyledTableCell>
              <StyledTableCell align="center">Photos</StyledTableCell>
              <StyledTableCell align="center">Event</StyledTableCell>
              <StyledTableCell align="center">Actions</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {galleries_excluding_photoart.map((row, index) => (
              <StyledTableRow
                hover
                className={
                  get(row, "available_to_purchase")
                    ? classes.available_to_purchase_gallery
                    : classes.unavailable_to_purchase_gallery
                }
                key={`${row.id}-styledrow`}
                selected={selectedRowId === row.id}
                onClick={() => {
                  selectGalleryWithDetail(row.id);
                }}
              >
                <StyledTableCell component="th" scope="row">
                  {moment(get(row, "shot_at_datetime")).format("Do MMM YYYY")}
                </StyledTableCell>
                <StyledTableCell align="left">
                  {get(row, "session_name")}
                </StyledTableCell>
                <StyledTableCell align="left" className={classes.photoCount}>
                  {get(row, "number_of_photos_in_gallery")}
                </StyledTableCell>
                <StyledTableCell align="left">
                  {get(row, "gallery_event_name", "N/A")}
                </StyledTableCell>
                <StyledTableCell align="left" className={classes.selectedInput}>
                  <SelectRow
                    row={row}
                    history={history}
                    dispatch={dispatch}
                    key={`${row.id}-selectrow`}
                    onDeleted={onDeleteSelectedGallery}
                    onAvailableToPurchase={onAvailableToPurchaseSelectedGallery}
                    onUnavailableToPurchase={
                      onUnavailableToPurchaseSelectedGallery
                    }
                  />
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      )}
      {!showMap && <Pagination item_list={galleryList} />}
      {showMap && (
        <Map
          markers={map(galleries, function (gallery) {
            return {
              imageUrl: galleryList.getGalleryAvatarUrl(gallery),
              name: gallery.gallery_name,
              position: { lat: gallery.lat, lng: gallery.lng },
              onClick: () => onSelectGallery(gallery.id),
            };
          })}
        />
      )}
    </TableContainer>
  );
};

export default AllGalleries;
